// Eagerly import Sonik-wrapped PrimeVue components used in layout/shared components so their
// theme CSS is present at startup rather than injected when a route first loads them.
// Without this, navigating to a page that uses Menu/Select causes a CSS shift on return.
import '@loopreturns/sonik/accordion';
import '@loopreturns/sonik/menu';
import '@loopreturns/sonik/select';
import '@loopreturns/sonik/card';
import '@loopreturns/sonik/button';
import '@loopreturns/sonik/inputtext';
import '@loopreturns/sonik/textarea';
import '@loopreturns/sonik/inputnumber';
import '@loopreturns/sonik/iconfield';
import '@loopreturns/sonik/menubar';
import '@loopreturns/sonik/progressspinner';
import '@loopreturns/sonik/progressbar';
import '@loopreturns/sonik/tag';
import '@loopreturns/sonik/message';
import '@loopreturns/sonik/dialog';
import '@loopreturns/sonik/confirmdialog';
import '@loopreturns/sonik/datepicker';
import '@loopreturns/sonik/iftalabel';
import '@loopreturns/sonik/skeleton';
import '@loopreturns/sonik/checkbox';
import '@loopreturns/sonik/chip';
import '@loopreturns/sonik/upload';
import '@loopreturns/sonik/toggleswitch';
import '@loopreturns/sonik/radiobutton';
import '@loopreturns/sonik/ripple';
import '@loopreturns/sonik/toolbar';
import '@loopreturns/sonik/panel';
import '@loopreturns/sonik/tabs';
import '@loopreturns/sonik/editor';
import '@loopreturns/sonik/datatable';

import { SonikConfig } from '@loopreturns/sonik';
import { ConfirmationService } from '@loopreturns/sonik/confirmdialog';
import { Ripple } from '@loopreturns/sonik/ripple';
import { ToastService } from '@loopreturns/sonik/toast';
import { Tooltip } from '@loopreturns/sonik/tooltip';
import type { App } from 'vue';

import { mxLoopAdminPreset } from '@/theme/mxLoopAdminPreset';

export const sonik = {
  install: (app: App) => {
    app.directive('tooltip', Tooltip);
    app.directive('ripple', Ripple);

    app.use(SonikConfig, {
      theme: {
        preset: mxLoopAdminPreset,
        options: {
          darkModeSelector: '.dark',
        },
      },
      zIndex: {
        tooltip: 100000,
      },
    });

    app.use(ToastService);
    app.use(ConfirmationService);
  },
};
